import React, { useEffect, createElement } from 'react';
export function TruConversion() {
  useEffect(() => {
    // Only load on deployed site, not in preview/iframe
    if (window.self !== window.top) return;
    try {
      if (!(window as any)._tip) {
        ;
        (window as any)._tip = [];
      }
      if (document.getElementById('ti-js')) return;
      const script = document.createElement('script');
      script.id = 'ti-js';
      script.async = true;
      script.src = 'https://app.truconversion.com/ti-js/62948/c116f.js';
      script.onerror = () => {};
      document.head.appendChild(script);
    } catch (e) {
      // Silent fail
    }
  }, []);
  return null;
}